module.exports = __webpack_public_path__ + "img/Background_Recruit.44c6e6c8.png";